import { Button, Link, Box, Container, Theme } from "@material-ui/core";
import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";

import enFlag from "../../assets/icons/united-kingdom.svg";
import nlFlag from "../../assets/icons/netherlands.svg";
import deFlag from "../../assets/icons/germany.svg";
import logo from "../../assets/routetitan_logo.svg";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import {headerIDs} from "../../qaIDs.json"

const useStyles = makeStyles((theme: Theme) => {
  return {
    langBtn: {
      padding: theme.spacing(1.25, 2)
    }
  };
});

function getFlag(language: string) {
  switch (language) {
    case 'nl':
      return nlFlag;
    case 'de':
      return deFlag;
    default:
      return enFlag;
  }
}

export default function Header({
  firstPage,
  language,
  changeLanguage
}: {
  firstPage: boolean;
  language: string;
  changeLanguage: (lng: string) => void;
}) {
  const [anchorEl, setAnchorEl] = useState<null | Element>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.SyntheticEvent<Element>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const classes = useStyles();

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderBottom: "1px solid #dddddd",
        marginBottom: firstPage ? 0 : 3
      }}
    >
      <Container>
        <Box
          display="flex"
          justifyContent="space-between"
          height={72}
          alignItems="center"
        >
          <Link id={headerIDs.headerLogo} href={process.env.REACT_APP_TT_URL}>
            <img alt="" src={logo} />
          </Link>
          <Button
            id={headerIDs.headerLanguageButton}
            aria-controls={headerIDs.headerLanguageButton}
            aria-haspopup="true"
            aria-expanded={Boolean(anchorEl) ? "true" : undefined}
            onClick={handleClick}
            className={classes.langBtn}
          >
          <img src={getFlag(language)} alt="" />
          </Button>
          <LanguageSelector
            anchorEl={anchorEl}
            handleClose={handleClose}
            language={language}
            setLanguage={changeLanguage}
            menuProps={{
              anchorOrigin: { vertical: "bottom", horizontal: "right" },
              transformOrigin: { vertical: "top", horizontal: "right" }
            }}
          />
        </Box>
      </Container>
    </Box>
  );
}
